import React from 'react'
import { ValueAndLabel } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import styles from './PriceBenchmarkValueLabels.module.css'

type PriceBenchmarkValueLabelsProps = {
  minValue: number
  maxValue: number
  recommendedValue: number
  minPosition: number
  maxPosition: number
  recommendedPosition: number
}

const formatCurrency = (value: number, language: string) =>
  `${value.toLocaleString(language, { maximumFractionDigits: 0 })} €`

type LabelStyle = React.CSSProperties & {
  '--price-benchmark-label-position': string
}

const getLabelStyle = (position: number): LabelStyle => ({
  '--price-benchmark-label-position': `${position}%`,
})

export function PriceBenchmarkValueLabels({
  minValue,
  maxValue,
  recommendedValue,
  minPosition,
  maxPosition,
  recommendedPosition,
}: PriceBenchmarkValueLabelsProps) {
  const { t, i18n } = useTranslation()

  return (
    <div className={styles.values}>
      <ValueAndLabel.Root
        size='small'
        textAlignment='centered'
        className={`${styles.value} ${styles.minValue}`}
        style={getLabelStyle(minPosition)}
      >
        <ValueAndLabel.Value>{formatCurrency(minValue, i18n.language)}</ValueAndLabel.Value>
      </ValueAndLabel.Root>
      <ValueAndLabel.Root
        size='small'
        textAlignment='centered'
        className={`${styles.value} ${styles.recommendedValue}`}
        style={getLabelStyle(recommendedPosition)}
      >
        <ValueAndLabel.Value>{formatCurrency(recommendedValue, i18n.language)}</ValueAndLabel.Value>
        <ValueAndLabel.Label>
          {t('wizard.screen.basicInfo.price.recommendedNotification.check.averageAskingRent')}
        </ValueAndLabel.Label>
      </ValueAndLabel.Root>
      <ValueAndLabel.Root
        size='small'
        textAlignment='centered'
        className={`${styles.value} ${styles.maxValue}`}
        style={getLabelStyle(maxPosition)}
      >
        <ValueAndLabel.Value>{formatCurrency(maxValue, i18n.language)}</ValueAndLabel.Value>
      </ValueAndLabel.Root>
    </div>
  )
}
